import { useCallback } from "react";
import { useQueryClient } from "react-query";
import { useGlobalPrivateChannelListener } from "../Hooks/useGlobalPrivateChannelListener";

export const UserAvailableJobTypesRealtime = () => {
  const queryClient = useQueryClient();

  const listener = useCallback(() => {
    queryClient.invalidateQueries(["available-job-types"]);
  }, [queryClient]);

  useGlobalPrivateChannelListener("UserAvailableJobTypesUpdated", listener);
  useGlobalPrivateChannelListener("JobTypeCreated", listener);
  useGlobalPrivateChannelListener("JobTypeDeleted", listener);
  useGlobalPrivateChannelListener("JobTypeMovedToArchive", listener);

  return null;
};
